// databricksPipelinesService.js
import { API_BASE_URL } from './config.js';
import fetchWrapper from '../components/utility/fetchWrapper.js';

export const databricksPipelinesService = {
  /**
   * Discover all Delta Live Tables (DLT) pipelines from a Databricks workspace
   * GET /api/v1/databricks/pipelines/discover?workspace_name=xxx
   */
  discoverPipelines: async (workspaceName) => {
    if (!workspaceName) throw new Error('workspace_name is required');
    const params = new URLSearchParams({ workspace_name: workspaceName });
    const response = await fetchWrapper(
      `${API_BASE_URL}/api/v1/databricks/pipelines/discover?${params}`
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to discover Databricks pipelines: ${errorText}`);
    }
    return await response.json();
  },

  /**
   * Enable monitoring for a Databricks pipeline
   * POST /api/v1/databricks/pipelines/enable?workspace_name=xxx&aws_account_id=xxx
   */
  enablePipeline: async (workspaceName, awsAccountId, { pipeline_id, enable_logs = true, enable_metrics = true }) => {
    if (!workspaceName || !awsAccountId || !pipeline_id) {
      throw new Error('workspace_name, aws_account_id, and pipeline_id are required');
    }
    const params = new URLSearchParams({
      workspace_name: workspaceName,
      aws_account_id: awsAccountId,
    });
    const response = await fetchWrapper(
      `${API_BASE_URL}/api/v1/databricks/pipelines/enable?${params}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pipeline_id, enable_logs, enable_metrics }),
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to enable pipeline: ${errorText}`);
    }
    return await response.json();
  },

  /**
   * Disable monitoring for a Databricks pipeline
   * POST /api/v1/databricks/pipelines/disable?pipeline_id=xxx&workspace_name=xxx&aws_account_id=xxx
   */
  disablePipeline: async (pipelineId, workspaceName, awsAccountId) => {
    if (!pipelineId || !workspaceName || !awsAccountId) {
      throw new Error('pipeline_id, workspace_name, and aws_account_id are required');
    }
    const params = new URLSearchParams({
      pipeline_id: pipelineId,
      workspace_name: workspaceName,
      aws_account_id: awsAccountId,
    });
    const response = await fetchWrapper(
      `${API_BASE_URL}/api/v1/databricks/pipelines/disable?${params}`,
      { method: 'POST', headers: { 'Content-Type': 'application/json' } }
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to disable pipeline: ${errorText}`);
    }
    return await response.json();
  },
};
